import { cn } from '@/lib/utils';

interface LogoMarkProps {
  /** Rendered width/height in px. */
  size?: number;
  className?: string;
}

/**
 * KundaliAI logo mark — renders the brand logo (public/logo-96.webp, derived
 * from public/kundaliai-logo.png, which is also the source for all
 * favicon/PWA icons via scripts/generate-pwa-icons.mjs).
 */
export function LogoMark({ size = 24, className }: LogoMarkProps) {
  return (
    <span
      className={cn(
        // Padded ring + violet glow lift the dark artwork off dark surfaces.
        'inline-flex items-center justify-center rounded-lg p-1 ring-1 ring-primary-400/40 drop-shadow-[0_0_8px_rgba(139,92,246,0.55)]',
        className
      )}
    >
      <img
        src="/logo-96.webp"
        width={size}
        height={size}
        alt=""
        aria-hidden="true"
        className="rounded-md"
      />
    </span>
  );
}
